import React, { Component } from 'react';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';

import { InjectedStyledComponent } from '../shared/InjectedStyledComponent.jsx';

import ClearButton from './styledComponents/ClearButton.jsx';
import DropdownComponent from './styledComponents/DropdownComponent.jsx';
import Label from './styledComponents/Label.jsx';
import LabelWrapper from './styledComponents/LabelWrapper';
import Pill from './styledComponents/Pill';
import Wrapper from './styledComponents/Wrapper';
import { IDropdownProps, IDropdownState } from './models';

export class RawDropdown extends Component<IDropdownProps, IDropdownState> {
	static configurationKey = 'dropdown' as const;
	static styleKey = 'dropdown' as const;

	constructor(props: IDropdownProps) {
		super(props);
		makeObservable(this, {
			labelProps: computed,
			pillProps: computed,
			clearButtonProps: computed,
		});
	}

	get labelProps() {
		const { componentProps, labelValue } = this.props.dropdownStore;
		const labelProps = componentProps.label || {};
		labelProps.value = labelValue;
		return labelProps;
	}

	get pillProps() {
		const { componentProps, selectionsCount, pillValue } = this.props.dropdownStore;
		const pillProps = componentProps.pill || {};
		pillProps.value = pillValue;
		pillProps.hide = selectionsCount === 0;
		return pillProps;
	}

	get clearButtonProps() {
		const { componentProps, selectionsCount, setValue } = this.props.dropdownStore;
		const clearButtonProps = componentProps.clearButton || {};
		clearButtonProps.onClick = () => {
			setValue();
		};
		clearButtonProps.hide = selectionsCount === 0;
		return clearButtonProps;
	}

	render() {
		const { className, dropdownStore } = this.props;

		if (!dropdownStore || !dropdownStore.show) {
			return null;
		}
		const { options, dropdownProps } = dropdownStore;

		return (
			<Wrapper className={className}>
				<LabelWrapper>
					<Label {...this.labelProps} />
					{options.showPill && <Pill {...this.pillProps} />}
					{options.showClearButton && <ClearButton {...this.clearButtonProps} />}
				</LabelWrapper>
				<DropdownComponent {...dropdownProps} />
			</Wrapper>
		);
	}
}

export const Dropdown = inject('appStore')(observer(RawDropdown));
export default InjectedStyledComponent(Dropdown, 'dropdown');
